"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const SupportingCreativeFormatAspectRatioItem_1 = require("./SupportingCreativeFormatAspectRatioItem");
class SupportingCreativeFormatAspectRatio {
    constructor({ id, availables, }) {
        this.toJSON = () => ({
            id: this.id,
            availables: this.availables.toJSON(),
        });
        this.id = id;
        this.availables = availables;
    }
}
SupportingCreativeFormatAspectRatio.fromJSON = (json) => {
    const { id, availables } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (!Array.isArray(availables))
        throw new Error('.availables must be an array');
    return new SupportingCreativeFormatAspectRatio({
        id,
        availables: immutable_1.List(availables).map(item => SupportingCreativeFormatAspectRatioItem_1.default.fromJSON(item)),
    });
};
exports.default = SupportingCreativeFormatAspectRatio;
